import { ClassNames } from '@emotion/core'
import * as React from 'react'
import ReactLightbox from 'react-image-lightbox'
import 'react-image-lightbox/style.css'

import { SchoolPage_school_profile_profileMedia } from '../gql'
import { lightboxStyles } from './Lightbox.styles'

interface IProps {
  index: number
  profileMedia: SchoolPage_school_profile_profileMedia[]
  onChangeIndex: (index: number) => void
  onRequestClose: () => void
}

export default function Lightbox(props: IProps) {
  const { index, profileMedia, onChangeIndex, onRequestClose } = props

  const main = profileMedia[index]
  const mainUrl = applyImageOperations(profileMedia[index].media.url)

  const next = profileMedia[nextIndex()]
  const nextUrl = next && applyImageOperations(next.media.url)

  const prev = profileMedia[prevIndex()]
  const prevUrl = prev && applyImageOperations(prev.media.url)

  return (
    <ClassNames>
      {({ css }) => (
        <ReactLightbox
          wrapperClassName={css(lightboxStyles)}
          mainSrc={mainUrl}
          nextSrc={nextUrl}
          prevSrc={prevUrl}
          imageCaption={mainCaption()}
          onCloseRequest={onRequestClose}
          onMovePrevRequest={handleMovePrevRequest}
          onMoveNextRequest={handleMoveNextRequest}
        />
      )}
    </ClassNames>
  )

  function handleMovePrevRequest() {
    onChangeIndex(prevIndex())
  }

  function handleMoveNextRequest() {
    onChangeIndex(nextIndex())
  }

  function mainCaption() {
    const { caption } = main
    const indexPart = `(${index + 1}/${profileMedia.length})`

    return `${caption ? `${caption} ` : ''}${indexPart}`
  }

  function nextIndex() {
    return (index + 1) % profileMedia.length
  }

  function prevIndex() {
    return (index - 1) % profileMedia.length
  }
}

function applyImageOperations(url: string) {
  return `${url}-/preview/2000x2000/-/format/auto/`
}
